module.exports = __webpack_public_path__ + "img/example-wechat-credit-pay03.e009b80e.png";